export default __webpack_public_path__ + "static/media/node.8e341cc0.png";